import { render, staticRenderFns } from "./userRoleCollapse.vue?vue&type=template&id=1e3af382&ref=userRoleCollapse&"
import script from "./userRoleCollapse.vue?vue&type=script&lang=js&"
export * from "./userRoleCollapse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports